const { BASE_URL } = require("./client");

const ROLE = BASE_URL + "/api/roles";
module.exports = {
  ROLE,
};
